<template>
	<section v-if="items.length" class="main-content contentblocks background-dark">
		<slot name="blocks-header" />
		<content-block
			v-for="item in items"
			:key="item.ID"
			:image="item.image"
			:image-webp="item.imageWebp ?? ''"
			:image-alt="item.imageAlt ?? ''"
			:header="item.header"
			:content="item.content"
			class="row contentblock"
		/>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.background-dark {
	background: url('~/assets/images/contentblock-bg-vertical.jpg') no-repeat center center;
	background-size: cover;
}
</style>
